import ScrollToHelper from './ScrollToHelper';
import GeneralHelper from './GeneralHelper';
import LinkFocusHelper from './LinkFocusHelper';

class AnchorLinkHelper {
    /**
     * add smooth scrolling behaviour to all anchor links;
     * lazysizes is passed for correct end position (images between anchor link and
     * target have to be loaded before scrolling for a correct end position)
     * @param lazysizes
     */
    static initializeAnchorLinks(lazysizes) {
        const links = document.querySelectorAll('a[href^="#"]');
        links.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();

                const href = event.currentTarget.getAttribute('href');

                if (href.length <= 1 || !href.match('^#')) {
                    return;
                }

                const targetId = GeneralHelper.getTargetIdFromUrl(href);
                const targetElement = document.getElementById(targetId);

                const customEvent = new CustomEvent('anchorClicked', {
                    detail: {
                        href,
                        targetId,
                    },
                });
                window.dispatchEvent(customEvent);

                if (targetElement) {
                    const imagesToLoad = ScrollToHelper.getAllImagesBetweenCurrentAndTarget(
                        event.currentTarget, targetElement,
                    );

                    imagesToLoad.forEach((image) => {
                        lazysizes.loader.unveil(image);
                    });

                    LinkFocusHelper.focusOnElement(targetId);
                    window.requestAnimationFrame(() => {
                        ScrollToHelper.scrollTo(targetElement);
                    });
                }
            });
        });
    }
}

export default AnchorLinkHelper;
